import { render, staticRenderFns } from "./UploadDocs.vue?vue&type=template&id=f3f1061a&scoped=true"
import script from "./UploadDocs.vue?vue&type=script&lang=js"
export * from "./UploadDocs.vue?vue&type=script&lang=js"
import style0 from "./UploadDocs.vue?vue&type=style&index=0&id=f3f1061a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f1061a",
  null
  
)

export default component.exports